import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';

import { useMembers } from 'Shared/utils/hooks';

import WpToastManager from 'Wpds/components/toast/WpToastManager';
import { useDeepEqualSelector, useWaitForCalendarWorkspacesSynced } from 'Shared/utils/hooks';
import QueryParamConstants from 'Shared/constants/QueryParams.constants';

import SyncMeetingsFlowForm from '../SyncMeetingsFlowForm/SyncMeetingsFlowForm';
import { SyncMeetingsSteps } from '../types';

const syncStatusRequestCondition = true;

type Props = {
  onToggle: Function;
};

const connectToCalSteps = [
  SyncMeetingsSteps.linkExistingMeetings,
  SyncMeetingsSteps.createNewTeammateWorkspaces,
  SyncMeetingsSteps.createNewGroupWorkspaces,
  SyncMeetingsSteps.inviteTeammates,
];

function ConnectToCalModal({ onToggle }: Props) {
  const history = useHistory();
  const recurringMeetings = useDeepEqualSelector(state =>
    state.user.recurringMeetings.filter(({ cancelled, hasWorkspace }) => !cancelled && !hasWorkspace)
  );
  const workspacesLoading = useSelector(state => state.loaders.workspacesLoading);
  const { isLoading: isLoadingMembers } = useMembers();

  const isLoading = useWaitForCalendarWorkspacesSynced({
    syncStatusRequestCondition,
    queryParams: { suggested_workspaces: true },
  });

  const redirectToAddTeammateModal = !isLoading && !recurringMeetings.length;

  useEffect(() => {
    if (redirectToAddTeammateModal)
      history.push(
        `${history.location.pathname}?${QueryParamConstants.ADD_TEAMMATE_MODAL}=true&${QueryParamConstants.FROM_CONNECT_TO_CAL}=true`
      );
  }, [redirectToAddTeammateModal]);

  if (redirectToAddTeammateModal) return null;

  const displaySuccessMessage = () => WpToastManager.success('You have successfully connected your calendar');
  return (
    <SyncMeetingsFlowForm
      onToggle={onToggle}
      onDisplaySuccessMessage={displaySuccessMessage}
      isLoading={isLoading || workspacesLoading || isLoadingMembers}
      steps={connectToCalSteps}
      recurringMeetings={recurringMeetings}
    />
  );
}

export default ConnectToCalModal;
